/**
 * UI-тексты интерактивных карт (GfInteractiveMap + адаптеры
 * CountryInteractiveMap / CityInteractiveMap).
 * Только UI-лейблы карты; данные точек приходят из Sanity/контента.
 * RU и EN имеют идентичную форму ключей.
 */
export const mapsUi = {
    en: {
        // GfInteractiveMap — popup actions
        popupExplore: 'Explore',
        popupDirections: 'Directions',
        // GfInteractiveMap — states / aria / hints
        ariaMap: 'Interactive map',
        loading: 'Loading map…',
        errorLoad: 'Map loading error',
        errorFailed: 'Failed to load map',
        centerNote: 'Centre',
        ariaLayers: 'Map layers',
        openInGoogle: 'Open in Google Maps →',
        enableLayerHint: 'Enable a layer above to show points',
        // CountryInteractiveMap
        country: {
            cities: 'Cities',
            placesKicker: 'Place',
            places: 'Places',
            airportKicker: 'Airport',
            airports: 'Airports',
            panelEyebrow: 'On the map',
            hint: 'Toggle layers in the legend; tap an item to zoom',
            aria: 'Interactive country map',
        },
        // CityInteractiveMap
        city: {
            km: 'km',
            attractions: 'Attractions',
            panelEyebrow: 'On the map',
            hint: 'Tap a place — the map zooms to it',
            aria: 'Interactive city map',
        },
        // AirportInteractiveMap
        airport: {
            km: 'km',
            cities: 'Nearby cities',
            panelEyebrow: 'On the map',
            hint: 'Tap a city — the map zooms to it',
            aria: (name) => `Interactive map of ${name}`,
        },
    },
    ru: {
        popupExplore: 'Открыть',
        popupDirections: 'Маршрут',
        ariaMap: 'Интерактивная карта',
        loading: 'Загрузка карты…',
        errorLoad: 'Ошибка загрузки карты',
        errorFailed: 'Не удалось загрузить карту',
        centerNote: 'Центр',
        ariaLayers: 'Слои карты',
        openInGoogle: 'Открыть в Google Картах →',
        enableLayerHint: 'Включите слой в легенде, чтобы показать точки',
        country: {
            cities: 'Города',
            placesKicker: 'Место',
            places: 'Места',
            airportKicker: 'Аэропорт',
            airports: 'Аэропорты',
            panelEyebrow: 'На карте',
            hint: 'Включайте и выключайте слои в легенде; нажмите пункт — карта приблизит точку',
            aria: 'Интерактивная карта страны',
        },
        city: {
            km: 'км',
            attractions: 'Достопримечательности',
            panelEyebrow: 'Места на карте',
            hint: 'Нажмите место — карта приблизит точку',
            aria: 'Интерактивная карта города',
        },
        airport: {
            km: 'км',
            cities: 'Города поблизости',
            panelEyebrow: 'На карте',
            hint: 'Нажмите город — карта приблизит точку',
            aria: (name) => `Интерактивная карта аэропорта ${name}`,
        },
    },
};
